import Reflux from 'reflux';
import moment from 'moment-timezone';
import LeadActions from 'actions/leadActions';

export default Reflux.createStore({
    listenables: LeadActions,

    init() {
        this.lead = {};
    },

    onLoadLead(lead) {
        this.lead = lead;
    },

    onSaveLead(lead) {
        lead.event.date = moment(lead.event.date);

        this.lead = lead;
        this.trigger(this.lead);
    },
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/stores/leadStore.jsx